import React from 'react';
import { Document, Page, Text } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import ResumePDFDocument from '../components/Career/Preview/ResumePDFDocument';
import { imageUrlToBase64 } from '@repo/common';
import { translateResumeData } from '../components/Career/Preview/TranslateResumeData';

export const useResumePdfDownload = (resumeData, resumeTitle) => {
  const handleDownload = async (option) => {
    try {
      let profileBase64 = null;
      if (resumeData?.profile?.profileUrl) {
        try {
          profileBase64 = await imageUrlToBase64(resumeData.profile.profileUrl);
        } catch (imgErr) {
          console.warn('프로필 이미지 변환 실패, 이미지 없이 진행:', imgErr);
          profileBase64 = null;
        }
      }

      const finalResumeData =
        option === 'korean'
          ? await translateResumeData(resumeData)
          : resumeData;

      const docData = {
        ...finalResumeData,
        profile: {
          ...finalResumeData.profile,
          profileUrl: profileBase64,
        },
      };

      const element = React.createElement(ResumePDFDocument, {
        resumeData: docData,
        lang: option === 'korean' ? 'KR' : 'ORIGINAL',
      });

      const blob = await pdf(element).toBlob();

      const defaultTitle = `${resumeData?.profile?.firstName ?? 'Firstname'}_${
        resumeData?.profile?.lastName ?? 'Lastname'
      }_Resume_${option === 'korean' ? 'KR' : 'EN'}`;

      const safeTitle = resumeTitle?.trim() || defaultTitle;

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${safeTitle}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('PDF 생성 중 오류:', error);
      alert(`PDF 생성에 실패했습니다: ${error.message}`);
    }
  };

  return { handleDownload };
};
